const l = {
  name: "DisplayFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 2C1.34315 2 0 3.34315 0 5V15C0 16.6569 1.34315 18 3 18H21C22.6569 18 24 16.6569 24 15V5C24 3.34315 22.6569 2 21 2H3Z" fill="currentColor"/>
<path d="M7 20V22H17V20H7Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as DisplayFilled
};
